import { jsx as o, jsxs as h, Fragment as W } from "react/jsx-runtime";
import { signOut as ge, fetchAuthSession as He, fetchUserAttributes as ct, getCurrentUser as ht, signInWithRedirect as $e, confirmSignIn as qe, signIn as wt, confirmResetPassword as pt, resetPassword as gt } from "aws-amplify/auth";
import { createContext as Ge, useState as u, useEffect as be, useContext as Be, lazy as ft, Suspense as mt } from "react";
import { useRouterState as Pt } from "@tanstack/react-router";
import { Stack as C, AssetWatchLogo as fe, Headline as xe, Text as U, Button as T, Tile as yt, Group as Ce, Title as je, Label as bt, Icon as Me, Input as ae, Checkbox as Ct, toast as St, BlockingActionOverlay as vt, Alert as Qe, Divider as It } from "@assetwatch/ui";
import { LDProvider as Et, useLDClient as Rt } from "launchdarkly-react-client-sdk";
import { cognitoUserPoolsTokenProvider as Lt } from "aws-amplify/auth/cognito";
import { CookieStorage as xt } from "aws-amplify/utils";
import { post as Tt } from "aws-amplify/api";
import { useMutation as Ke } from "@tanstack/react-query";
function Nt(e) {
  return e.startsWith("http://") || e.startsWith("https://") ? e : `https://${e}`;
}
function Oe(e) {
  const r = new URL(
    "/logout",
    Nt(e.domain)
  );
  r.searchParams.set("client_id", e.clientId), r.searchParams.set("logout_uri", e.redirectUri), window.location.assign(r.toString());
}
async function kt(e) {
  await ge(), !(typeof window > "u" || !e?.clientId || !e.domain || !e.redirectUri) && Oe(e);
}
async function $t(e) {
  const r = typeof window < "u" && e?.clientId && e.domain && e.redirectUri ? e : void 0;
  try {
    await ge({ global: !0 });
  } catch (t) {
    if (!r)
      throw t;
    try {
      Oe(r);
    } catch {
    }
    throw t;
  }
  r && Oe(r);
}
const Ye = Ge(void 0);
function Tr({
  children: e,
  fetchUserData: r,
  validateAuthenticatedUser: t,
  signOutRedirect: s
}) {
  const [n, a] = u(!1), [i, d] = u(!0), [w, g] = u(null), [l, p] = u(null);
  be(() => {
    c();
  }, [r, t]);
  async function c() {
    try {
      const f = await He();
      if (f.tokens) {
        const z = await ct(), H = f.tokens.accessToken?.payload?.["cognito:groups"], x = Array.isArray(H) ? H.filter((_) => typeof _ == "string") : [], Y = await ht(), G = f.tokens.idToken?.payload?.identities, k = {
          email: z.email || "",
          role: z["custom:role"] || "",
          sub: z.sub || "",
          cognitoGroups: x,
          username: Y.username,
          name: typeof f.tokens.idToken?.payload?.name == "string" ? f.tokens.idToken.payload.name : void 0,
          isSsoUser: Array.isArray(G) && G.length > 0
        }, O = r ? await r({ session: f, baseUser: k }) : {}, V = {
          ...k,
          ...O,
          cognitoGroups: O.cognitoGroups ?? k.cognitoGroups
        };
        if (t) {
          const _ = await t({
            session: f,
            user: V
          });
          if (!_.ok) {
            await ge(), p(_.message), a(!1), g(null);
            return;
          }
        }
        p(null), g(V), a(!0);
      } else
        a(!1), g(null);
    } catch {
      a(!1), g(null);
    } finally {
      d(!1);
    }
  }
  async function b() {
    try {
      p(null), await $e();
    } catch (f) {
      if (f instanceof Error && f.name === "UserAlreadyAuthenticatedException")
        await c();
      else
        throw f;
    }
  }
  async function N() {
    await kt(s), await c();
  }
  async function I() {
    await $t(s), await c();
  }
  const R = {
    isAuthenticated: n,
    isLoading: i,
    validationError: l,
    refreshAuth: c,
    user: w,
    signIn: b,
    signOut: N,
    signOutEverywhere: I
  };
  return /* @__PURE__ */ o(Ye.Provider, { value: R, children: e });
}
function Je() {
  const e = Be(Ye);
  if (e === void 0)
    throw new Error("useAuth must be used within an AuthProvider");
  return e;
}
const Mt = ft(
  () => import("./CelebrationGraphic-DKEoWOy6.js").then((e) => ({
    default: e.CelebrationGraphic
  }))
);
function Ot({
  isLoading: e,
  messages: r,
  onStartMonitoring: t
}) {
  const s = r.actions.startMonitoring ?? "Start monitoring";
  return /* @__PURE__ */ h(W, { children: [
    /* @__PURE__ */ h(C, { align: "center", gap: 16, children: [
      /* @__PURE__ */ o(fe, { "aria-hidden": !0, size: "display", tone: "default" }),
      /* @__PURE__ */ o(xe, { align: "center", as: "h1", size: "sm", children: r.headings.accountCreatedTitle }),
      /* @__PURE__ */ o("div", { className: "w-full max-w-[334px]", children: /* @__PURE__ */ o(U, { align: "center", tone: "subtext", children: r.headings.accountCreatedDescription }) })
    ] }),
    /* @__PURE__ */ h(C, { align: "center", gap: 40, children: [
      /* @__PURE__ */ o(mt, { fallback: null, children: /* @__PURE__ */ o(Mt, { size: "xl" }) }),
      /* @__PURE__ */ o(
        T,
        {
          "data-testid": "start-monitoring-button",
          fullWidth: !0,
          loading: e,
          loadingText: r.loading.redirecting,
          type: "button",
          onClick: t,
          children: s
        }
      )
    ] })
  ] });
}
const Se = {
  digitRequirement: "contain at least one digit",
  lowercaseRequirement: "contain at least one lowercase letter",
  uppercaseRequirement: "contain at least one uppercase letter",
  specialCharacterRequirement: "contain at least one special character",
  lengthRequirement: "be at least 10 characters in length, but not more than 32",
  previousPasswordRequirement: "not one of your previous 12 passwords (verified after submission)",
  passwordStrength: {
    weak: "Weak",
    fair: "Fair",
    strong: "Strong"
  }
};
function At(e) {
  return [
    e.hasLowercase,
    e.hasUppercase,
    e.hasNumber,
    e.hasSpecialCharacter,
    e.hasSufficientLength
  ];
}
function _t({
  isPassedPasswordHistory: e,
  requirements: r,
  showPreviousPasswordRequirement: t
}) {
  const s = At(r), n = t ? [...s, e === !0] : s;
  return n.some(Boolean) ? n.every(Boolean) ? "strong" : r.hasLowercase && r.hasUppercase && r.hasSufficientLength ? "fair" : "weak" : null;
}
function Dt(e) {
  return e === "weak" ? "negative" : e === "fair" ? "warning" : "positive";
}
function Ft(e) {
  return e === void 0 ? {
    icon: "warning",
    tone: "warning"
  } : e ? {
    icon: "circle-check",
    tone: "positive"
  } : {
    icon: "circle-xmark-solid",
    tone: "negative"
  };
}
function pe({
  children: e,
  isSatisfied: r,
  variant: t = "list"
}) {
  if (t === "panel")
    return /* @__PURE__ */ h(Ce, { align: "center", gap: 8, children: [
      /* @__PURE__ */ o(
        Me,
        {
          "aria-hidden": !0,
          name: "circle-check-regular",
          size: "sm",
          tone: r ? "positive" : "secondary"
        }
      ),
      /* @__PURE__ */ o(U, { as: "span", size: "sm", children: e })
    ] });
  const { icon: s, tone: n } = Ft(r);
  return /* @__PURE__ */ h(Ce, { align: "start", gap: 8, children: [
    /* @__PURE__ */ o(Me, { "aria-hidden": !0, name: s, size: "sm", tone: n }),
    /* @__PURE__ */ o(U, { size: "sm", tone: "subtext", children: e })
  ] });
}
function Ze({
  requirements: e,
  isPassedPasswordHistory: r,
  labels: t = Se,
  showPreviousPasswordRequirement: s = !0,
  title: n,
  variant: a = "list"
}) {
  const i = a === "panel" ? _t({
    isPassedPasswordHistory: r,
    requirements: e,
    showPreviousPasswordRequirement: s
  }) : null, d = i ? t.passwordStrength?.[i] ?? Se.passwordStrength?.[i] : void 0, w = /* @__PURE__ */ h(C, { gap: a === "panel" ? 10 : 8, children: [
    /* @__PURE__ */ o(pe, { isSatisfied: e.hasLowercase, variant: a, children: t.lowercaseRequirement }),
    /* @__PURE__ */ o(pe, { isSatisfied: e.hasUppercase, variant: a, children: t.uppercaseRequirement }),
    /* @__PURE__ */ o(pe, { isSatisfied: e.hasNumber, variant: a, children: t.digitRequirement }),
    /* @__PURE__ */ o(
      pe,
      {
        isSatisfied: e.hasSpecialCharacter,
        variant: a,
        children: t.specialCharacterRequirement
      }
    ),
    /* @__PURE__ */ o(
      pe,
      {
        isSatisfied: e.hasSufficientLength,
        variant: a,
        children: t.lengthRequirement
      }
    ),
    s ? /* @__PURE__ */ o(pe, { isSatisfied: r, variant: a, children: t.previousPasswordRequirement }) : null
  ] });
  return a === "panel" ? /* @__PURE__ */ o(yt, { padding: "dense", radius: "sm", tone: "muted", width: "full", children: /* @__PURE__ */ h(C, { gap: 8, children: [
    n || d ? /* @__PURE__ */ h(Ce, { justify: "between", children: [
      n ? /* @__PURE__ */ o(je, { as: "span", size: "sm", children: n }) : null,
      i && d ? /* @__PURE__ */ o(bt, { size: "md", tone: Dt(i), children: d }) : null
    ] }) : null,
    w
  ] }) }) : w;
}
function qt({
  authType: e,
  firstSignIn: r,
  isTemporaryPasswordChallenge: t,
  messages: s
}) {
  return /* @__PURE__ */ h(C, { align: "center", gap: 16, children: [
    t ? /* @__PURE__ */ o(fe, { size: "display", "aria-hidden": !0 }) : /* @__PURE__ */ o(fe, { "aria-hidden": !0, size: "stacked", tone: "default" }),
    t ? /* @__PURE__ */ h(W, { children: [
      /* @__PURE__ */ o(xe, { align: "center", as: "h1", size: "sm", children: s.headings.updatePasswordTitle }),
      /* @__PURE__ */ o(U, { align: "center", tone: "subtext", children: s.headings.updatePasswordDescription })
    ] }) : (e === "basic" || e === "temporaryPassword") && !r ? /* @__PURE__ */ o(U, { align: "center", tone: "subtext", children: s.headings.signInDescription }) : /* @__PURE__ */ o(xe, { align: "center", as: "h1", size: "sm", children: s.headings.signInTitle })
  ] });
}
function Ut({
  authType: e,
  email: r,
  emailError: t,
  isCheckingEmail: s,
  isRememberMeEnabled: n,
  messages: a,
  onCheckEmail: i,
  onEmailChange: d,
  onRememberMeChange: w
}) {
  return e === "mfacode" || e === "basic" || e === "temporaryPassword" ? null : /* @__PURE__ */ h(W, { children: [
    /* @__PURE__ */ o(
      ae,
      {
        autoFocus: !0,
        "data-testid": "email-input",
        disabled: !!e || s,
        error: t ?? void 0,
        label: a.labels.email,
        onChange: (g) => d(g.currentTarget.value),
        placeholder: a.placeholders.email,
        reserveSubtextSpace: !1,
        type: "email",
        value: r
      }
    ),
    e === "" ? /* @__PURE__ */ h(C, { gap: 40, children: [
      /* @__PURE__ */ o(
        Ct,
        {
          checked: n,
          "data-testid": "remember-me",
          label: a.actions.rememberMe,
          onCheckedChange: (g) => w(!!g),
          size: "sm"
        }
      ),
      /* @__PURE__ */ o(
        T,
        {
          "data-testid": "continue-button",
          fullWidth: !0,
          loading: s,
          loadingText: a.loading.checking,
          disabled: !!t,
          type: "button",
          onClick: i,
          children: a.actions.continue
        }
      )
    ] }) : null
  ] });
}
function Vt({
  canSubmit: e,
  email: r,
  isLoading: t,
  isPasswordVisible: s,
  messages: n,
  onPasswordChange: a,
  onPasswordVisibilityChange: i,
  password: d,
  passwordError: w,
  passwordVisibilityLabel: g
}) {
  return /* @__PURE__ */ h(C, { gap: 40, children: [
    /* @__PURE__ */ h(C, { gap: 16, children: [
      /* @__PURE__ */ h(U, { children: [
        n.copy.temporaryPasswordPrompt,
        /* @__PURE__ */ o("br", {}),
        /* @__PURE__ */ o("strong", { children: r.trim().toLowerCase() })
      ] }),
      /* @__PURE__ */ o(
        Te,
        {
          autoFocus: !0,
          error: w,
          isVisible: s,
          label: n.labels.password,
          onChange: a,
          onVisibilityChange: i,
          reserveSubtextSpace: !1,
          value: d,
          visibilityLabel: g
        }
      )
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "login-button",
        disabled: !e,
        fullWidth: !0,
        loading: t,
        loadingText: n.loading.loggingIn,
        type: "submit",
        children: n.actions.login
      }
    ),
    /* @__PURE__ */ o(U, { align: "center", children: n.copy.temporaryPasswordHelp })
  ] });
}
function Wt({
  canSubmit: e,
  email: r,
  forgotPasswordUrl: t,
  isLoading: s,
  isPasswordVisible: n,
  messages: a,
  onChangeEmail: i,
  onPasswordChange: d,
  onPasswordVisibilityChange: w,
  password: g,
  passwordError: l,
  passwordVisibilityLabel: p
}) {
  return /* @__PURE__ */ h(C, { align: "center", gap: 40, children: [
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "change-email-button",
        icon: "edit-pen",
        size: "sm",
        type: "button",
        variant: "outline",
        onClick: i,
        children: r.trim().toLowerCase()
      }
    ),
    /* @__PURE__ */ h(C, { gap: 4, fullWidth: !0, children: [
      /* @__PURE__ */ o(
        Te,
        {
          autoFocus: !0,
          error: l,
          isVisible: n,
          label: a.labels.password,
          onChange: d,
          onVisibilityChange: w,
          reserveSubtextSpace: !1,
          value: g,
          visibilityLabel: p
        }
      ),
      t ? /* @__PURE__ */ o(C, { align: "end", fullWidth: !0, children: /* @__PURE__ */ o(
        T,
        {
          render: /* @__PURE__ */ o("a", { href: t, children: a.actions.forgotPassword }),
          size: "sm",
          variant: "ghost",
          children: a.actions.forgotPassword
        }
      ) }) : null
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "login-button",
        disabled: !e,
        fullWidth: !0,
        loading: s,
        loadingText: a.loading.loggingIn,
        type: "submit",
        children: a.actions.login
      }
    )
  ] });
}
function zt({
  canSubmit: e,
  confirmPassword: r,
  confirmPasswordVisibilityLabel: t,
  isConfirmPasswordVisible: s,
  isLoading: n,
  isNewPasswordVisible: a,
  isTemporaryPasswordChallenge: i,
  messages: d,
  newPassword: w,
  newPasswordError: g,
  newPasswordVisibilityLabel: l,
  onConfirmPasswordChange: p,
  onConfirmPasswordVisibilityChange: c,
  onNewPasswordChange: b,
  onNewPasswordVisibilityChange: N,
  passedPasswordHistory: I,
  passwordValidation: R
}) {
  const f = i ? d.actions.saveChanges ?? "Save changes" : d.actions.setNewPassword;
  return /* @__PURE__ */ h(W, { children: [
    /* @__PURE__ */ h(C, { gap: 16, children: [
      i ? null : /* @__PURE__ */ o(U, { tone: "subtext", children: d.copy.newPasswordPrompt }),
      /* @__PURE__ */ o(
        Te,
        {
          dataTestId: "new-password-input",
          error: g,
          isVisible: a,
          label: d.labels.newPassword,
          onChange: b,
          onVisibilityChange: N,
          value: w,
          visibilityLabel: l
        }
      ),
      /* @__PURE__ */ o(
        Ze,
        {
          isPassedPasswordHistory: I,
          labels: d.passwordRequirements,
          requirements: R,
          showPreviousPasswordRequirement: !i,
          title: i ? d.copy.passwordRequirementsHeading : void 0,
          variant: i ? "panel" : "list"
        }
      ),
      /* @__PURE__ */ o(
        Te,
        {
          dataTestId: "confirm-password-input",
          error: r.length > 0 && !R.matchesConfirm ? d.copy.confirmPasswordMismatch : null,
          isVisible: s,
          label: d.labels.confirmPassword,
          onChange: p,
          onVisibilityChange: c,
          value: r,
          visibilityLabel: t
        }
      )
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "login-button",
        disabled: !e,
        fullWidth: !0,
        loading: n,
        loadingText: d.loading.updatingPassword,
        type: "submit",
        children: f
      }
    )
  ] });
}
function Ht({
  canSubmit: e,
  isLoading: r,
  messages: t,
  mfaCode: s,
  onMfaCodeChange: n
}) {
  return /* @__PURE__ */ h(W, { children: [
    /* @__PURE__ */ h(C, { gap: 16, children: [
      /* @__PURE__ */ h(C, { gap: 8, children: [
        /* @__PURE__ */ o(je, { as: "h2", size: "lg", children: t.headings.twoFactorTitle }),
        /* @__PURE__ */ o(U, { tone: "subtext", children: t.headings.twoFactorDescription })
      ] }),
      /* @__PURE__ */ o(
        ae,
        {
          autoFocus: !0,
          "data-testid": "mfa-code-input",
          label: t.labels.verificationCode,
          onChange: (a) => n(a.currentTarget.value),
          type: "text",
          value: s
        }
      )
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        "data-testid": "submit-mfa",
        disabled: !e,
        fullWidth: !0,
        loading: r,
        loadingText: t.loading.verifying,
        type: "submit",
        children: t.actions.submit
      }
    )
  ] });
}
function Gt({
  messages: e,
  password: r
}) {
  return /* @__PURE__ */ o(
    ae,
    {
      "data-testid": "password-input",
      disabled: !0,
      label: e.labels.password,
      type: "password",
      value: r
    }
  );
}
function Te({
  autoFocus: e,
  dataTestId: r = "password-input",
  error: t,
  isVisible: s,
  label: n,
  onChange: a,
  onVisibilityChange: i,
  reserveSubtextSpace: d = !0,
  value: w,
  visibilityLabel: g
}) {
  return /* @__PURE__ */ o(
    ae,
    {
      autoFocus: e,
      "data-testid": r,
      error: t ?? void 0,
      label: n,
      onChange: (l) => a(l.currentTarget.value),
      reserveSubtextSpace: d,
      trailingAction: {
        icon: s ? "eye-watching" : "eye-slash-regular",
        "aria-label": g,
        "aria-pressed": s,
        onClick: i
      },
      type: s ? "text" : "password",
      value: w
    }
  );
}
const K = {
  accessibility: {
    assetWatchLogoAriaLabel: "AssetWatch",
    hidePassword: "Hide password",
    showPassword: "Show password"
  },
  headings: {
    signInTitle: "Sign In",
    signInDescription: "Authenticate with your AssetWatch account.",
    updatePasswordTitle: "Let's update your password",
    updatePasswordDescription: "Create a strong password to secure your account",
    accountCreatedTitle: "Account created successfully.",
    accountCreatedDescription: "Your account is ready - start monitoring assets and preventing downtime.",
    twoFactorTitle: "Two-factor authentication",
    twoFactorDescription: "Enter the code from your authenticator app."
  },
  labels: {
    email: "Email",
    password: "Password",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    verificationCode: "Verification Code"
  },
  placeholders: {
    email: "Email"
  },
  actions: {
    rememberMe: "Remember me",
    continue: "Continue",
    forgotPassword: "Forgot password?",
    reachOutToSupport: "support@assetwatch.com",
    login: "Login",
    loginWithSso: "Login with SSO",
    retry: "Retry",
    saveChanges: "Save changes",
    startMonitoring: "Start monitoring",
    setNewPassword: "Set New Password",
    changeEmail: "Change Email",
    submit: "Submit"
  },
  loading: {
    checking: "Checking",
    updatingPassword: "Updating password",
    loggingIn: "Logging in",
    verifying: "Verifying",
    redirecting: "Redirecting",
    ssoRedirecting: "Signing in with SSO..."
  },
  copy: {
    newPasswordPrompt: "Please enter a new password to replace the temporary one. Your new password must:",
    passwordRequirementsHeading: "Your password must include",
    temporaryPasswordPrompt: "Please enter the temporary password we sent to:",
    temporaryPasswordHelp: "Need a new temporary password? Contact your CSM.",
    confirmPasswordMismatch: "Passwords do not match.",
    supportQuestion: "Questions?"
  },
  status: {
    passwordUpdatedSuccess: "Password updated successfully. Please log in with your new password.",
    temporaryPasswordUpdatedSuccess: "Temporary password updated successfully. Please log in with your new password."
  },
  errors: {
    invalidEmail: "Please enter a valid email.",
    incorrectEmailOrPassword: "Incorrect email or password.",
    accountNotConfirmed: "Your account isn't confirmed. Please check your email for a verification code.",
    passwordResetRequired: "You must reset your password before signing in. Please use 'Forgot password?' to reset.",
    tooManyAttempts: "Too many attempts. Please wait and try again later.",
    network: "Network error. Please check your connection and try again.",
    generic: "Something went wrong. Please try again.",
    passwordHistoryViolation: "This password was used previously. Please choose a new password that you haven't used in your last 12 passwords.",
    invalidPasswordPolicy: "Password does not meet the policy requirements.",
    updatePasswordGeneric: "Error updating password. Please try again.",
    invalidMfaCode: "Invalid MFA code entered. Please try again.",
    identityProviderUndefined: "Identity provider is not defined.",
    unsupportedSignInStep: "Unsupported sign-in step."
  },
  passwordRequirements: Se
}, Re = {
  hasUppercase: !1,
  hasLowercase: !1,
  hasNumber: !1,
  hasSpecialCharacter: !1,
  hasSufficientLength: !1,
  matchesConfirm: !0
}, Ae = "sso_post_login_redirect";
function Xe(e) {
  return typeof e == "string" && e.startsWith("/") && !e.startsWith("//") && !e.startsWith("/\\");
}
function Bt(e) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/.test(
    e
  );
}
function jt(e, r) {
  return {
    hasUppercase: e.toLowerCase() !== e,
    hasLowercase: e.toUpperCase() !== e,
    hasNumber: /[0-9]/.test(e),
    hasSpecialCharacter: /[^a-zA-Z0-9]/.test(e),
    hasSufficientLength: e.length >= 10 && e.length <= 32,
    matchesConfirm: e === r
  };
}
function Qt() {
  const e = sessionStorage.getItem(Ae);
  return sessionStorage.removeItem(Ae), Xe(e) ? e : null;
}
function Ue(e) {
  sessionStorage.setItem(Ae, e);
}
function Ve(e, r) {
  const t = e, s = t.name ?? t.code ?? t.__type?.split("#").pop() ?? "", n = String(t.message ?? "");
  return (s === "NotAuthorizedException" || s === "NotAuthorized") && /incorrect username or password/i.test(n) || s === "UserNotFoundException" ? r.errors.incorrectEmailOrPassword : s === "UserNotConfirmedException" ? r.errors.accountNotConfirmed : s === "PasswordResetRequiredException" ? r.errors.passwordResetRequired : s === "LimitExceededException" || s === "TooManyRequestsException" ? r.errors.tooManyAttempts : /Failed to fetch|NetworkError/i.test(n) ? r.errors.network : r.errors.generic;
}
function Kt(e) {
  const r = e, t = r.name ?? r.code ?? r.__type?.split("#").pop() ?? "", s = String(r.message ?? "");
  return t === "UserNotFoundException" || (t === "NotAuthorizedException" || t === "NotAuthorized") && /incorrect username or password/i.test(s);
}
function We(e, r) {
  const t = e, s = t.name ?? t.code ?? "", n = String(t.message ?? "");
  return s === "PasswordHistoryPolicyViolationException" ? r.errors.passwordHistoryViolation : s === "InvalidPasswordException" ? r.errors.invalidPasswordPolicy : s === "LimitExceededException" || s === "TooManyRequestsException" ? r.errors.tooManyAttempts : /Failed to fetch|NetworkError/i.test(n) ? r.errors.network : r.errors.updatePasswordGeneric;
}
function Yt(e) {
  const r = e, t = r.name ?? r.code ?? r.__type?.split("#").pop() ?? "";
  return t === "PasswordHistoryPolicyViolationException" || t === "InvalidPasswordException";
}
function Jt({
  authenticate: e,
  forgotPasswordHref: r,
  initialEmail: t = "",
  initialStatusMessage: s,
  isAuthenticated: n,
  lookupLoginMethod: a,
  messages: i,
  onNavigate: d,
  passwordUpdated: w = !1,
  redirectTo: g = "/"
}) {
  const l = {
    ...K,
    ...i,
    headings: {
      ...K.headings,
      ...i?.headings
    },
    actions: {
      ...K.actions,
      ...i?.actions
    },
    loading: {
      ...K.loading,
      ...i?.loading
    },
    copy: { ...K.copy, ...i?.copy },
    status: {
      ...K.status,
      ...i?.status
    }
  }, p = Xe(g) ? g : "/", [c, b] = u(""), [N, I] = u(""), [R, f] = u(t), [z, H] = u(null), [x, Y] = u(!1), [G, k] = u(), [O, V] = u(!1), [_, B] = u(!1), [ue, L] = u(!1), [E, $] = u(!1), [le, oe] = u(!1), [M, D] = u(!1), [F, se] = u(!1), [ce, J] = u(!1), [ie, de] = u(""), [Z, A] = u(""), [he, X] = u(null), [we, j] = u(void 0), [ee, Q] = u(""), [me, te] = u(null), [q, re] = u(
    Re
  ), [v, m] = u(
    s ? "negative" : w ? "positive" : "informative"
  ), [Ee, S] = u(
    s ?? (w ? l.status.passwordUpdatedSuccess : null)
  );
  be(() => {
    const P = localStorage.getItem("rememberMeLogin");
    P && (f(P), se(!0));
  }, []), be(() => {
    m(
      s ? "negative" : w ? "positive" : "informative"
    ), S(
      s ?? (w ? l.status.passwordUpdatedSuccess : null)
    );
  }, [
    s,
    l.status.passwordUpdatedSuccess,
    w
  ]), be(() => {
    n && d(Qt() ?? p);
  }, [n, d, p]);
  function Pe() {
    b(""), I(""), Y(!1), k(void 0), V(!1), de(""), A(""), X(null), Q(""), te(null), $(!1), oe(!1), D(!1), re(Re), j(void 0), J(!1), S(null), m("informative");
  }
  function y() {
    return x ? q.hasUppercase && q.hasLowercase && q.hasNumber && q.hasSpecialCharacter && q.hasSufficientLength && q.matchesConfirm : c === "mfacode" ? ie.length === 6 : R.trim().length > 0 && ee.length > 0;
  }
  async function ye(P) {
    if (!P) {
      m("negative"), S(l.errors.identityProviderUndefined);
      return;
    }
    k(P), L(!0), J(!0), S(null), m("informative");
    try {
      await ge(), p !== "/" && Ue(p), await $e({
        provider: { custom: P },
        customState: JSON.stringify({ isWebLogin: "true" })
      });
    } catch (ne) {
      J(!1), m("negative"), S(Ve(ne, l));
    } finally {
      L(!1);
    }
  }
  async function Fe() {
    const P = R.trim().toLowerCase();
    if (te(null), !Bt(P)) {
      H(l.errors.invalidEmail);
      return;
    }
    H(null), F ? localStorage.setItem("rememberMeLogin", P) : localStorage.removeItem("rememberMeLogin");
    try {
      B(!0);
      const ne = await a(P);
      ne.authType === "sso" ? await ye(ne.identityProvider) : b(ne.authType);
    } catch {
      b("basic"), St.error(l.errors.network, {
        action: {
          label: l.actions.retry ?? "Retry",
          onClick: () => {
            Fe();
          }
        }
      });
    } finally {
      B(!1);
    }
  }
  async function st() {
    if (x) {
      if (Z !== N)
        return;
      L(!0);
      try {
        X(null);
        const ne = (await qe({ challengeResponse: Z })).nextStep.signInStep;
        if (ne === "CONFIRM_SIGN_IN_WITH_TOTP_CODE") {
          b("mfacode"), I(""), Y(!1), de(""), A(""), Q(""), re(Re), j(void 0), S(null), m("informative");
          return;
        }
        if (ne !== "DONE") {
          m("negative"), S(l.errors.unsupportedSignInStep);
          return;
        }
        c === "temporaryPassword" ? (I(""), A(""), j(!0), Q(""), re(Re), S(null), V(!0)) : (j(!0), m("positive"), S(
          l.status.temporaryPasswordUpdatedSuccess ?? K.status.temporaryPasswordUpdatedSuccess ?? "Temporary password updated successfully. Please log in with your new password."
        ), await new Promise((ut) => setTimeout(ut, 500)), await ge(), Pe());
      } catch (P) {
        j(!1), Yt(P) ? (X(We(P, l)), S(null)) : (m("negative"), S(We(P, l)));
      } finally {
        L(!1);
      }
      return;
    }
    if (L(!0), S(null), m("informative"), c === "mfacode") {
      try {
        if ((await qe({ challengeResponse: ie })).nextStep.signInStep !== "DONE") {
          m("negative"), S(l.errors.unsupportedSignInStep);
          return;
        }
        await e();
      } catch {
        m("negative"), S(l.errors.invalidMfaCode);
      } finally {
        L(!1);
      }
      return;
    }
    if (await ge(), c === "sso") {
      if (!G) {
        m("negative"), S(l.errors.identityProviderUndefined), L(!1);
        return;
      }
      p !== "/" && Ue(p), await $e({
        provider: { custom: G },
        customState: JSON.stringify({ isWebLogin: "true" })
      }), L(!1);
      return;
    }
    try {
      switch (te(null), (await wt({
        username: R.trim().toLowerCase(),
        password: ee,
        options: {
          clientMetadata: {
            isWebLogin: "true"
          }
        }
      })).nextStep.signInStep) {
        case "RESET_PASSWORD":
          m("negative"), S(l.errors.passwordResetRequired);
          break;
        case "CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED":
          Y(!0);
          break;
        case "CONFIRM_SIGN_IN_WITH_TOTP_CODE":
          b("mfacode");
          break;
        case "DONE":
          await e();
          break;
        default:
          m("negative"), S(l.errors.unsupportedSignInStep);
      }
    } catch (P) {
      console.error(
        "[CustomLoginForm.handleSubmit]",
        JSON.stringify({
          message: P instanceof Error ? P.message : String(P),
          name: P instanceof Error ? P.name : void 0
        })
      ), m("negative"), Kt(P) ? (te(l.errors.incorrectEmailOrPassword), S(null)) : S(Ve(P, l));
    } finally {
      L(!1);
    }
  }
  async function it() {
    L(!0);
    try {
      await e();
    } finally {
      L(!1);
    }
  }
  const nt = typeof r == "function" ? r(R.trim().toLowerCase()) : r, at = M ? l.accessibility.hidePassword : l.accessibility.showPassword, lt = le ? l.accessibility.hidePassword : l.accessibility.showPassword, dt = E ? l.accessibility.hidePassword : l.accessibility.showPassword;
  return {
    authType: c,
    checkEmail: Fe,
    confirmPassword: N,
    confirmPasswordVisibilityLabel: dt,
    email: R,
    emailError: z,
    firstSignIn: x,
    forgotPasswordUrl: nt,
    handleSubmit: st,
    isAccountCreated: O,
    isCheckingEmail: _,
    isConfirmPasswordVisible: E,
    isFormValid: y,
    isLoading: ue,
    isNewPasswordVisible: le,
    isPasswordVisible: M,
    isRememberMeEnabled: F,
    isSsoRedirecting: ce,
    isTemporaryPasswordChallenge: c === "temporaryPassword" && x,
    messages: l,
    mfaCode: ie,
    newPassword: Z,
    newPasswordError: he,
    newPasswordVisibilityLabel: lt,
    passedPasswordHistory: we,
    password: ee,
    passwordError: me,
    passwordValidation: q,
    passwordVisibilityLabel: at,
    resetAuthState: Pe,
    setConfirmPassword: I,
    setEmail: f,
    setEmailError: H,
    setIsConfirmPasswordVisible: $,
    setIsNewPasswordVisible: oe,
    setIsPasswordVisible: D,
    setIsRememberMeEnabled: se,
    setMfaCode: de,
    setNewPassword: A,
    setNewPasswordError: X,
    setPassedPasswordHistory: j,
    setPassword: Q,
    setPasswordError: te,
    setPasswordValidation: re,
    startMonitoring: it,
    statusMessage: Ee,
    statusTone: v
  };
}
function Zt({
  authenticate: e,
  forgotPasswordHref: r,
  initialEmail: t = "",
  initialStatusMessage: s,
  isAuthenticated: n,
  lookupLoginMethod: a,
  messages: i,
  onNavigate: d,
  passwordUpdated: w = !1,
  redirectTo: g = "/",
  supportHref: l
}) {
  const {
    authType: p,
    checkEmail: c,
    confirmPassword: b,
    confirmPasswordVisibilityLabel: N,
    email: I,
    emailError: R,
    firstSignIn: f,
    forgotPasswordUrl: z,
    handleSubmit: H,
    isAccountCreated: x,
    isCheckingEmail: Y,
    isConfirmPasswordVisible: G,
    isFormValid: k,
    isLoading: O,
    isNewPasswordVisible: V,
    isPasswordVisible: _,
    isRememberMeEnabled: B,
    isSsoRedirecting: ue,
    isTemporaryPasswordChallenge: L,
    messages: E,
    mfaCode: $,
    newPassword: le,
    newPasswordError: oe,
    newPasswordVisibilityLabel: M,
    passedPasswordHistory: D,
    password: F,
    passwordError: se,
    passwordValidation: ce,
    passwordVisibilityLabel: J,
    resetAuthState: ie,
    setConfirmPassword: de,
    setEmail: Z,
    setEmailError: A,
    setIsConfirmPasswordVisible: he,
    setIsNewPasswordVisible: X,
    setIsPasswordVisible: we,
    setIsRememberMeEnabled: j,
    setMfaCode: ee,
    setNewPassword: Q,
    setNewPasswordError: me,
    setPassedPasswordHistory: te,
    setPassword: q,
    setPasswordError: re,
    setPasswordValidation: v,
    startMonitoring: m,
    statusMessage: Ee,
    statusTone: S
  } = Jt({
    authenticate: e,
    forgotPasswordHref: r,
    initialEmail: t,
    initialStatusMessage: s,
    isAuthenticated: n,
    lookupLoginMethod: a,
    messages: i,
    onNavigate: d,
    passwordUpdated: w,
    redirectTo: g,
    supportHref: l
  }), Pe = E.actions.reachOutToSupport ?? K.actions.reachOutToSupport;
  return /* @__PURE__ */ o("div", { className: "w-full bg-surface-low", children: /* @__PURE__ */ o(
    vt,
    {
      label: E.loading.ssoRedirecting ?? "",
      open: ue,
      children: /* @__PURE__ */ h("div", { className: "relative flex min-h-screen w-full flex-col items-stretch", children: [
        /* @__PURE__ */ o("header", { className: "flex h-(--spacing-64) w-full items-center border-b border-outline-subtle bg-surface px-(--spacing-16)", children: /* @__PURE__ */ o(
          fe,
          {
            "aria-label": E.accessibility.assetWatchLogoAriaLabel
          }
        ) }),
        /* @__PURE__ */ o("div", { className: "flex w-full flex-1 justify-center px-(--spacing-20) pt-(--spacing-40) pb-(--spacing-24) sm:pt-(--spacing-80) sm:pb-(--spacing-40)", children: /* @__PURE__ */ o(
          "form",
          {
            className: "w-full max-w-[480px]",
            "data-testid": "login-form",
            noValidate: !0,
            onSubmit: (y) => {
              y.preventDefault(), p === "" ? c() : (p === "sso" || k()) && H();
            },
            children: /* @__PURE__ */ o(C, { gap: 40, children: x ? /* @__PURE__ */ o(
              Ot,
              {
                isLoading: O,
                messages: E,
                onStartMonitoring: () => {
                  m();
                }
              }
            ) : /* @__PURE__ */ h(W, { children: [
              /* @__PURE__ */ o(
                qt,
                {
                  authType: p,
                  firstSignIn: f,
                  isTemporaryPasswordChallenge: L,
                  messages: E
                }
              ),
              Ee ? /* @__PURE__ */ o(Qe, { tone: S, title: Ee }) : null,
              /* @__PURE__ */ h(C, { gap: 16, children: [
                /* @__PURE__ */ o(
                  Ut,
                  {
                    authType: p,
                    email: I,
                    emailError: R,
                    isCheckingEmail: Y,
                    isRememberMeEnabled: B,
                    messages: E,
                    onCheckEmail: () => {
                      c();
                    },
                    onEmailChange: (y) => {
                      Z(y), A(null);
                    },
                    onRememberMeChange: j
                  }
                ),
                p === "temporaryPassword" && !f ? /* @__PURE__ */ o(
                  Vt,
                  {
                    canSubmit: k(),
                    email: I,
                    isLoading: O,
                    isPasswordVisible: _,
                    messages: E,
                    onPasswordChange: (y) => {
                      q(y), re(null);
                    },
                    onPasswordVisibilityChange: () => we((y) => !y),
                    password: F,
                    passwordError: se,
                    passwordVisibilityLabel: J
                  }
                ) : null,
                p === "basic" ? f ? /* @__PURE__ */ o(
                  Gt,
                  {
                    messages: E,
                    password: F
                  }
                ) : /* @__PURE__ */ o(
                  Wt,
                  {
                    canSubmit: k(),
                    email: I,
                    forgotPasswordUrl: z,
                    isLoading: O,
                    isPasswordVisible: _,
                    messages: E,
                    onChangeEmail: () => ie(),
                    onPasswordChange: (y) => {
                      q(y), re(null);
                    },
                    onPasswordVisibilityChange: () => we((y) => !y),
                    password: F,
                    passwordError: se,
                    passwordVisibilityLabel: J
                  }
                ) : null,
                f ? /* @__PURE__ */ o(
                  zt,
                  {
                    canSubmit: k(),
                    confirmPassword: b,
                    confirmPasswordVisibilityLabel: N,
                    isConfirmPasswordVisible: G,
                    isLoading: O,
                    isNewPasswordVisible: V,
                    isTemporaryPasswordChallenge: L,
                    messages: E,
                    newPassword: le,
                    newPasswordError: oe,
                    newPasswordVisibilityLabel: M,
                    onConfirmPasswordChange: (y) => {
                      de(y), v((ye) => ({
                        ...ye,
                        matchesConfirm: y === le
                      }));
                    },
                    onConfirmPasswordVisibilityChange: () => he((y) => !y),
                    onNewPasswordChange: (y) => {
                      Q(y), me(null), v(
                        jt(y, b)
                      ), te(
                        (ye) => ye === !1 ? !1 : void 0
                      );
                    },
                    onNewPasswordVisibilityChange: () => X((y) => !y),
                    passedPasswordHistory: D,
                    passwordValidation: ce
                  }
                ) : null,
                p === "mfacode" ? /* @__PURE__ */ o(
                  Ht,
                  {
                    canSubmit: k(),
                    isLoading: O,
                    messages: E,
                    mfaCode: $,
                    onMfaCodeChange: ee
                  }
                ) : null
              ] })
            ] }) })
          }
        ) }),
        l && !(p === "temporaryPassword" && !f || x) ? /* @__PURE__ */ o("footer", { className: "w-full px-(--spacing-20) pb-(--spacing-24) sm:pb-(--spacing-40)", children: /* @__PURE__ */ h(Ce, { gap: 0, justify: "center", children: [
          /* @__PURE__ */ o(U, { tone: "subtext", children: E.copy.supportQuestion }),
          /* @__PURE__ */ o(
            T,
            {
              children: Pe,
              icon: "arrow-up-right",
              render: /* @__PURE__ */ o("a", { href: l, "aria-label": Pe }),
              size: "sm",
              variant: "ghost"
            }
          )
        ] }) }) : null
      ] })
    }
  ) });
}
function Nr({
  children: e,
  loadingFallback: r,
  lookupLoginMethod: t,
  loginMessages: s,
  supportHref: n,
  renderAuthenticated: a
}) {
  const { isAuthenticated: i, isLoading: d, refreshAuth: w, user: g, validationError: l } = Je(), p = Pt({
    select: (c) => c.location.pathname + c.location.searchStr
  });
  return p.startsWith("/login/reset") ? /* @__PURE__ */ o(W, { children: e }) : d ? /* @__PURE__ */ o(W, { children: r }) : i ? /* @__PURE__ */ o(W, { children: a?.({ children: e, user: g }) ?? e }) : /* @__PURE__ */ o(
    Zt,
    {
      authenticate: w,
      forgotPasswordHref: (c) => `/login/reset?email=${encodeURIComponent(c)}`,
      initialStatusMessage: l ?? void 0,
      isAuthenticated: i,
      lookupLoginMethod: t,
      messages: s,
      onNavigate: (c) => {
        window.location.replace(c);
      },
      redirectTo: p,
      supportHref: n
    }
  );
}
function et(e) {
  return typeof Request < "u" && e instanceof Request;
}
function Xt(e, r) {
  const t = r?.method ?? (et(e) ? e.method : "GET"), s = typeof e == "string" ? e : e instanceof URL ? e.toString() : e.url;
  return { method: t.toUpperCase(), url: s };
}
function er(e, r) {
  const t = new Headers(et(e) ? e.headers : void 0);
  return r?.headers && new Headers(r.headers).forEach((s, n) => {
    t.set(n, s);
  }), t;
}
function Ne(e, r) {
  try {
    e?.(r);
  } catch {
  }
}
function kr({
  createRequestId: e,
  getAdditionalHeaders: r,
  onBreadcrumb: t
}) {
  return async (s, n) => {
    const a = await He(), i = a.tokens?.idToken?.toString() ?? a.tokens?.accessToken?.toString(), d = er(s, n), w = e(), { method: g, url: l } = Xt(s, n), p = Date.now();
    i && d.set("Authorization", `Bearer ${i}`), d.set("X-Request-Id", w), r && new Headers(r()).forEach((c, b) => {
      d.set(b, c);
    }), Ne(t, { phase: "request", method: g, url: l, requestId: w });
    try {
      const c = await fetch(s, { ...n, headers: d });
      return Ne(t, {
        phase: "response",
        method: g,
        url: l,
        requestId: w,
        statusCode: c.status,
        durationMs: Date.now() - p
      }), c;
    } catch (c) {
      throw Ne(t, {
        phase: "error",
        method: g,
        url: l,
        requestId: w,
        durationMs: Date.now() - p,
        errorName: c instanceof Error ? c.name : "UnknownError"
      }), c;
    }
  };
}
function tr(e) {
  return e.authType === "sso" || e.authorize_href && e.identityProvider ? e.identityProvider ? {
    authType: "sso",
    identityProvider: e.identityProvider
  } : { authType: "basic" } : e.authType === "temporaryPassword" || e.requiresTempPassword || e.userStatus === "FORCE_CHANGE_PASSWORD" || e.status === "FORCE_CHANGE_PASSWORD" ? { authType: "temporaryPassword" } : { authType: "basic" };
}
function $r(e) {
  return async (r) => {
    if (!e)
      return { authType: "basic" };
    const t = await fetch(`${e}/user/usertype`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ user_email: r })
    });
    if (t.status === 404)
      return { authType: "basic" };
    if (!t.ok)
      throw new Error(`Auth lookup failed with ${t.status}`);
    return tr(
      await t.json()
    );
  };
}
const _e = "NikolaTeam";
function rr(e) {
  if (!e?.trim())
    return !1;
  const r = e.trim();
  return r === _e ? !0 : r.split(/[,;]/).map((t) => t.trim()).some((t) => t === _e);
}
function or(e) {
  return e ? rr(e.role) ? !0 : e.cognitoGroups.includes(_e) : !1;
}
const De = Ge({
  isReady: !0
});
function sr({
  children: e,
  context: r,
  isReadyToIdentify: t
}) {
  const s = Rt(), [n, a] = u(null), i = JSON.stringify(r);
  return be(() => {
    if (!s) {
      a(null);
      return;
    }
    if (!t) {
      a(null);
      return;
    }
    let d = !1;
    return a(null), Promise.resolve(s.identify(JSON.parse(i))).catch(() => {
    }).finally(() => {
      d || a(i);
    }), () => {
      d = !0;
    };
  }, [i, t, s]), /* @__PURE__ */ o(
    De.Provider,
    {
      value: {
        isReady: t && n === i
      },
      children: e
    }
  );
}
function Mr() {
  return Be(De);
}
function Or({
  children: e,
  clientSideID: r,
  getContext: t = ({ user: n }) => ({
    kind: "user",
    key: n?.sub ?? "anonymous",
    email: n?.email ?? "",
    role: n?.role ?? "",
    roles: n?.roles ?? [],
    cognitoGroups: n?.cognitoGroups ?? [],
    isInternalUser: or(n)
  }),
  isReadyToIdentify: s = ({ isAuthenticated: n, isLoading: a, user: i }) => !a && n && !!i?.sub && !!i?.email
}) {
  const n = Je();
  if (!r)
    return /* @__PURE__ */ o(De.Provider, { value: { isReady: !0 }, children: e });
  const a = t(n);
  return /* @__PURE__ */ o(Et, { clientSideID: r, context: {
    kind: "user",
    key: "anonymous",
    anonymous: !0
  }, children: /* @__PURE__ */ o(
    sr,
    {
      context: a,
      isReadyToIdentify: s(n),
      children: e
    }
  ) });
}
const ze = {
  prod: {
    USER_POOL_ID: "us-east-2_MqZrrppS1",
    APP_CLIENT_ID: "7phcejhgai3vf6rj7mr526akc",
    IDENTITY_POOL_ID: "us-east-2:9ea0609d-9c44-4356-ae9e-6d38aa1898a1",
    DOMAIN: "auth-idp.assetwatch.com"
  },
  qa: {
    USER_POOL_ID: "us-east-2_tGB8JmQO3",
    APP_CLIENT_ID: "30ajgh20k1njb80coevmf9v1kr",
    IDENTITY_POOL_ID: "us-east-2:e6134d6f-3cbb-4c0f-a61a-7e1e184a4e59",
    DOMAIN: "auth-idp.qa.qa.assetwatch.com"
  },
  dev: {
    USER_POOL_ID: "us-east-2_x7NmjJEZB",
    APP_CLIENT_ID: "3urf9oqfossk0dv7eacrkl4p4h",
    IDENTITY_POOL_ID: "us-east-2:f2b106f4-7e58-4fe5-9576-59bfdd75cfe0",
    DOMAIN: "auth-idp.dev.dev.assetwatch.com"
  }
}, ir = [
  "USER_POOL_ID",
  "APP_CLIENT_ID",
  "IDENTITY_POOL_ID",
  "DOMAIN"
];
function Ar({
  allowFallback: e = !1,
  deployEnvironment: r,
  injectedConfig: t
}) {
  const s = ir.map((i) => [i, t?.[i]]), n = s.filter(([, i]) => !i).map(([i]) => `VITE_COGNITO_${i}`);
  if (t && n.length !== s.length) {
    if (n.length > 0)
      throw new Error(
        `Incomplete Cognito config. Missing: ${n.join(", ")}`
      );
    return t;
  }
  if (!e)
    throw new Error(
      `Cognito config is required. Missing: ${n.join(", ")}`
    );
  return ze[r] ?? ze.dev;
}
function nr(e) {
  if (e === "prod" || e === "qa-legacy") return ".assetwatch.com";
  const { hostname: r } = window.location, t = r.split(".");
  if (t.length >= 5) return "." + t.slice(1).join(".");
  if (t.length === 4) return "." + r;
}
function _r(e) {
  Lt.setKeyValueStorage(
    new xt({
      domain: nr(e),
      secure: window.location.protocol === "https:",
      sameSite: "lax",
      expires: 30
    })
  );
}
function tt(e, r) {
  return {
    digitRequirement: e(
      `${r}.auth.passwordRequirements.digitRequirement`
    ),
    lowercaseRequirement: e(
      `${r}.auth.passwordRequirements.lowercaseRequirement`
    ),
    uppercaseRequirement: e(
      `${r}.auth.passwordRequirements.uppercaseRequirement`
    ),
    specialCharacterRequirement: e(
      `${r}.auth.passwordRequirements.specialCharacterRequirement`
    ),
    lengthRequirement: e(
      `${r}.auth.passwordRequirements.lengthRequirement`
    ),
    previousPasswordRequirement: e(
      `${r}.auth.passwordRequirements.previousPasswordRequirement`
    ),
    passwordStrength: {
      weak: e(`${r}.auth.passwordRequirements.passwordStrength.weak`),
      fair: e(`${r}.auth.passwordRequirements.passwordStrength.fair`),
      strong: e(
        `${r}.auth.passwordRequirements.passwordStrength.strong`
      )
    }
  };
}
function Dr(e, { commonNamespace: r, namespace: t }) {
  return {
    accessibility: {
      assetWatchLogoAriaLabel: e(`${r}.assetWatchLabel`),
      hidePassword: e(`${t}.auth.signIn.hidePassword`),
      showPassword: e(`${t}.auth.signIn.showPassword`)
    },
    headings: {
      signInTitle: e(`${t}.auth.signIn.title`),
      signInDescription: e(`${t}.auth.signIn.description`),
      updatePasswordTitle: e(`${t}.auth.signIn.updatePasswordTitle`),
      updatePasswordDescription: e(
        `${t}.auth.signIn.updatePasswordDescription`
      ),
      accountCreatedTitle: e(`${t}.auth.signIn.accountCreatedTitle`),
      accountCreatedDescription: e(
        `${t}.auth.signIn.accountCreatedDescription`
      ),
      twoFactorTitle: e(`${t}.auth.signIn.twoFactorTitle`),
      twoFactorDescription: e(`${t}.auth.signIn.twoFactorDescription`)
    },
    labels: {
      email: e(`${t}.auth.signIn.emailLabel`),
      password: e(`${t}.auth.signIn.passwordLabel`),
      newPassword: e(`${t}.auth.signIn.newPasswordLabel`),
      confirmPassword: e(`${t}.auth.signIn.confirmPasswordLabel`),
      verificationCode: e(`${t}.auth.signIn.verificationCodeLabel`)
    },
    placeholders: {
      email: e(`${t}.auth.signIn.emailPlaceholder`)
    },
    actions: {
      rememberMe: e(`${t}.auth.signIn.rememberMe`),
      continue: e(`${t}.auth.signIn.continue`),
      forgotPassword: e(`${t}.auth.signIn.forgotPassword`),
      reachOutToSupport: e(`${t}.auth.signIn.reachOutToSupport`),
      login: e(`${t}.auth.signIn.login`),
      loginWithSso: e(`${t}.auth.signIn.loginWithSso`),
      retry: e(`${t}.auth.signIn.retry`),
      saveChanges: e(`${t}.auth.signIn.saveChanges`),
      startMonitoring: e(`${t}.auth.signIn.startMonitoring`),
      setNewPassword: e(`${t}.auth.signIn.setNewPassword`),
      changeEmail: e(`${t}.auth.signIn.changeEmail`),
      submit: e(`${t}.auth.signIn.submit`)
    },
    loading: {
      checking: e(`${t}.auth.signIn.loading.checking`),
      updatingPassword: e(`${t}.auth.signIn.loading.updatingPassword`),
      loggingIn: e(`${t}.auth.signIn.loading.loggingIn`),
      verifying: e(`${t}.auth.signIn.loading.verifying`),
      redirecting: e(`${t}.auth.signIn.loading.redirecting`),
      ssoRedirecting: e(`${t}.auth.signIn.loading.ssoRedirecting`)
    },
    copy: {
      newPasswordPrompt: e(`${t}.auth.signIn.newPasswordPrompt`),
      passwordRequirementsHeading: e(
        `${t}.auth.signIn.passwordRequirementsHeading`
      ),
      temporaryPasswordPrompt: e(
        `${t}.auth.signIn.temporaryPasswordPrompt`
      ),
      temporaryPasswordHelp: e(
        `${t}.auth.signIn.temporaryPasswordHelp`
      ),
      confirmPasswordMismatch: e(
        `${t}.auth.signIn.confirmPasswordMismatch`
      ),
      supportQuestion: e(`${t}.auth.signIn.supportQuestion`)
    },
    status: {
      passwordUpdatedSuccess: e(
        `${t}.auth.signIn.status.passwordUpdated`
      ),
      temporaryPasswordUpdatedSuccess: e(
        `${t}.auth.signIn.status.temporaryPasswordUpdated`
      )
    },
    errors: {
      invalidEmail: e(`${t}.auth.signIn.errors.invalidEmail`),
      incorrectEmailOrPassword: e(
        `${t}.auth.signIn.errors.incorrectEmailOrPassword`
      ),
      accountNotConfirmed: e(
        `${t}.auth.signIn.errors.accountNotConfirmed`
      ),
      passwordResetRequired: e(
        `${t}.auth.signIn.errors.passwordResetRequired`
      ),
      tooManyAttempts: e(`${t}.auth.signIn.errors.tooManyAttempts`),
      network: e(`${t}.auth.signIn.errors.network`),
      generic: e(`${t}.auth.signIn.errors.generic`),
      passwordHistoryViolation: e(
        `${t}.auth.signIn.errors.passwordHistoryViolation`
      ),
      invalidPasswordPolicy: e(`${t}.auth.signIn.errors.invalidPasswordPolicy`) || K.errors.invalidPasswordPolicy,
      updatePasswordGeneric: e(`${t}.auth.signIn.errors.updatePasswordGeneric`) || K.errors.updatePasswordGeneric,
      invalidMfaCode: e(`${t}.auth.signIn.errors.invalidMfaCode`),
      identityProviderUndefined: e(
        `${t}.auth.signIn.errors.identityProviderUndefined`
      ),
      unsupportedSignInStep: e(
        `${t}.auth.signIn.errors.unsupportedSignInStep`
      )
    },
    passwordRequirements: tt(e, t)
  };
}
function Fr(e, { commonNamespace: r, namespace: t }) {
  return {
    assetWatchLabel: e(`${r}.assetWatchLabel`),
    backToSignIn: e(`${t}.auth.passwordReset.backToSignIn`),
    confirmNewPasswordLabel: e(
      `${t}.auth.passwordReset.confirmPasswordLabel`
    ),
    continueToSignIn: e(`${t}.auth.passwordReset.continueToSignIn`),
    description: e(`${t}.auth.passwordReset.description`),
    emailLabel: e(`${t}.auth.passwordReset.emailLabel`),
    emailPlaceholder: e(`${t}.auth.passwordReset.emailPlaceholder`),
    emailSentMessage: e(`${t}.auth.passwordReset.emailSentMessage`),
    emailSentTitle: e(`${t}.auth.passwordReset.emailSentTitle`),
    expiredLinkDescription: e(
      `${t}.auth.passwordReset.expiredLinkDescription`
    ),
    expiredLinkTitle: e(`${t}.auth.passwordReset.expiredLinkTitle`),
    forgotPasswordDescription: e(
      `${t}.auth.passwordReset.forgotPasswordDescription`
    ),
    forgotPasswordTitle: e(
      `${t}.auth.passwordReset.forgotPasswordTitle`
    ),
    hidePassword: e(`${t}.auth.signIn.hidePassword`),
    loadingSendingCode: e(
      `${t}.auth.passwordReset.loading.sendingCode`
    ),
    loadingUpdatingPassword: e(
      `${t}.auth.passwordReset.loading.updatingPassword`
    ),
    newPasswordLabel: e(`${t}.auth.passwordReset.newPasswordLabel`),
    passwordRequirementsIntro: e(
      `${t}.auth.passwordReset.passwordRequirementsIntro`
    ),
    passwordSavedMessage: e(
      `${t}.auth.passwordReset.passwordSavedMessage`
    ),
    passwordSavedTitle: e(`${t}.auth.passwordReset.passwordSavedTitle`),
    passwordsDoNotMatch: e(
      `${t}.auth.passwordReset.passwordsDoNotMatch`
    ),
    reachOutToSupport: e(`${t}.auth.signIn.reachOutToSupport`),
    resetCodeLabel: e(`${t}.auth.passwordReset.resetCodeLabel`),
    saveChanges: e(`${t}.auth.passwordReset.saveChanges`),
    sendNewLink: e(`${t}.auth.passwordReset.sendNewLink`),
    sendResetCode: e(`${t}.auth.passwordReset.sendResetCode`),
    showPassword: e(`${t}.auth.signIn.showPassword`),
    supportQuestion: e(`${t}.auth.signIn.supportQuestion`),
    title: e(`${t}.auth.passwordReset.title`),
    errors: {
      codeMismatch: e(`${t}.auth.passwordReset.errors.codeMismatch`),
      expiredCode: e(`${t}.auth.passwordReset.errors.expiredCode`),
      generic: e(`${t}.auth.passwordReset.errors.generic`),
      invalidPassword: e(
        `${t}.auth.passwordReset.errors.invalidPassword`
      ),
      limitExceeded: e(`${t}.auth.passwordReset.errors.limitExceeded`),
      passwordHistoryViolation: e(
        `${t}.auth.passwordReset.errors.passwordHistoryViolation`
      ),
      unverifiedContact: e(
        `${t}.auth.passwordReset.errors.unverifiedContact`
      ),
      userNotFound: e(`${t}.auth.passwordReset.errors.userNotFound`)
    },
    passwordRequirements: tt(e, t) ?? Se
  };
}
function qr({
  apiName: e = "apiVeroUser",
  notProvisionedMessage: r = (t) => `User ${t} not found. Please contact support.`
} = {}) {
  return async ({ user: t }) => {
    const { body: s } = await Tt({
      apiName: e,
      path: "/list",
      options: {
        body: {
          meth: "getCurrentUserInfo"
        }
      }
    }).response;
    return (await s.json()).email ? { ok: !0 } : {
      ok: !1,
      message: r(t.sub)
    };
  };
}
function ar(e, r) {
  return {
    hasUppercase: e.toLowerCase() !== e,
    hasLowercase: e.toUpperCase() !== e,
    hasNumber: /[0-9]/.test(e),
    hasSpecialCharacter: /[^a-zA-Z0-9]/.test(e),
    hasSufficientLength: e.length >= 10 && e.length <= 32,
    matchesConfirm: e === r
  };
}
function lr(e) {
  return e.hasUppercase && e.hasLowercase && e.hasNumber && e.hasSpecialCharacter && e.hasSufficientLength && e.matchesConfirm;
}
function ve(e) {
  return typeof e == "object" && e !== null;
}
function Le(e, r) {
  const t = e[r];
  return typeof t == "string" ? t : void 0;
}
function Ie(e) {
  return Le(e, "name") ?? Le(e, "code") ?? Le(e, "__type")?.split("#").pop() ?? "";
}
function ke(e, r) {
  if (!ve(e))
    return r.errors.generic;
  const t = Ie(e), s = Le(e, "message") ?? "";
  return t === "InvalidPasswordException" ? r.errors.invalidPassword : t === "InvalidParameterException" && s.includes("no registered/verified email") ? r.errors.unverifiedContact : {
    CodeMismatchException: r.errors.codeMismatch,
    ExpiredCodeException: r.errors.expiredCode,
    LimitExceededException: r.errors.limitExceeded,
    TooManyRequestsException: r.errors.limitExceeded,
    UserNotFoundException: r.errors.userNotFound
  }[t] ?? (s || r.errors.generic);
}
function dr(e) {
  return ve(e) && Ie(e) === "ExpiredCodeException";
}
function ur(e) {
  return ve(e) && Ie(e) === "CodeMismatchException";
}
function cr(e) {
  if (!ve(e))
    return !1;
  const r = Ie(e);
  return r === "PasswordHistoryPolicyViolationException" || r === "InvalidPasswordException";
}
function hr(e, r) {
  return ve(e) && Ie(e) === "PasswordHistoryPolicyViolationException" ? r.errors.passwordHistoryViolation : r.errors.invalidPassword;
}
function wr({
  canSendCode: e,
  email: r,
  isSendingCode: t,
  messages: s,
  onEmailChange: n,
  onSubmit: a
}) {
  return /* @__PURE__ */ o("form", { onSubmit: a, children: /* @__PURE__ */ h(C, { gap: 40, children: [
    /* @__PURE__ */ o(
      ae,
      {
        autoComplete: "email",
        label: s.emailLabel,
        onChange: n,
        placeholder: s.emailPlaceholder,
        type: "email",
        value: r
      }
    ),
    /* @__PURE__ */ o(
      T,
      {
        disabled: !e,
        fullWidth: !0,
        loading: t,
        loadingText: s.loadingSendingCode,
        type: "submit",
        children: s.sendResetCode
      }
    )
  ] }) });
}
function pr({
  canConfirm: e,
  confirmPassword: r,
  isConfirming: t,
  messages: s,
  newPassword: n,
  newPasswordError: a,
  onConfirmPasswordChange: i,
  onNewPasswordChange: d,
  onResetCodeChange: w,
  onSubmit: g,
  passwordValidation: l,
  resetCode: p,
  showResetCodeInput: c
}) {
  const [b, N] = u(!1), [I, R] = u(!1);
  return /* @__PURE__ */ o("form", { onSubmit: g, children: /* @__PURE__ */ h(C, { gap: 40, children: [
    /* @__PURE__ */ h(C, { gap: 16, children: [
      c ? /* @__PURE__ */ o(
        ae,
        {
          autoComplete: "one-time-code",
          label: s.resetCodeLabel,
          onChange: w,
          value: p
        }
      ) : null,
      /* @__PURE__ */ o(
        ae,
        {
          autoComplete: "new-password",
          error: a ?? void 0,
          label: s.newPasswordLabel,
          onChange: d,
          trailingAction: {
            icon: b ? "eye-watching" : "eye-slash-regular",
            "aria-label": b ? s.hidePassword : s.showPassword,
            "aria-pressed": b,
            onClick: () => N((f) => !f)
          },
          type: b ? "text" : "password",
          value: n
        }
      ),
      /* @__PURE__ */ o(
        Ze,
        {
          labels: s.passwordRequirements ?? Se,
          requirements: l,
          showPreviousPasswordRequirement: !1,
          title: s.passwordRequirementsIntro,
          variant: "panel"
        }
      ),
      /* @__PURE__ */ o(
        ae,
        {
          autoComplete: "new-password",
          error: r.length > 0 && !l.matchesConfirm ? s.passwordsDoNotMatch : void 0,
          label: s.confirmNewPasswordLabel,
          onChange: i,
          trailingAction: {
            icon: I ? "eye-watching" : "eye-slash-regular",
            "aria-label": I ? s.hidePassword : s.showPassword,
            "aria-pressed": I,
            onClick: () => R((f) => !f)
          },
          type: I ? "text" : "password",
          value: r
        }
      )
    ] }),
    /* @__PURE__ */ o(
      T,
      {
        disabled: !e,
        fullWidth: !0,
        loading: t,
        loadingText: s.loadingUpdatingPassword,
        type: "submit",
        children: s.saveChanges
      }
    )
  ] }) });
}
function Ur({
  confirmPasswordReset: e,
  initialCode: r = "",
  initialEmail: t = "",
  initialExpired: s = !1,
  isConfirming: n,
  isSendingCode: a,
  messages: i,
  onNavigateToSignIn: d,
  sendPasswordResetCode: w,
  supportHref: g = "mailto:support@assetwatch.com"
}) {
  const [l, p] = u(t), [c, b] = u(r), [N, I] = u(""), [R, f] = u(null), [z, H] = u(""), [x, Y] = u(!1), [G, k] = u(!!r && !!t), [O, V] = u(!!s && !!t), [_] = u(
    !!r && !!t
  ), [B, ue] = u(s), [L, E] = u(!1), [$, le] = u(!1), [oe, M] = u(null), D = l.trim().toLowerCase(), F = c.trim().length > 0, se = D.length > 0 && !a, ce = ar(N, z), J = D.length > 0 && F && lr(ce) && !n;
  async function ie(v) {
    if (v?.preventDefault(), !!se) {
      M(null);
      try {
        if (he) {
          k(!0);
          return;
        }
        if (X) {
          V(!0);
          return;
        }
        await w(D), Y(!0), ue(!1), E(!1), V(!1), b(""), M(null);
      } catch (m) {
        M({
          tone: "negative",
          message: ke(m, i)
        });
      }
    }
  }
  async function de(v) {
    if (v.preventDefault(), !!J) {
      M(null), f(null);
      try {
        await e({
          username: D,
          confirmationCode: c.trim(),
          newPassword: N
        }), le(!0), M(null);
      } catch (m) {
        dr(m) ? (ue(!0), V(D.length > 0), M(null)) : ur(m) ? (E(!0), M({
          tone: "negative",
          message: ke(m, i)
        })) : cr(m) ? (f(hr(m, i)), M(null)) : M({
          tone: "negative",
          message: ke(m, i)
        });
      }
    }
  }
  const Z = !$ && x && !B, A = !$ && B, he = !$ && !x && F && !G && !B, X = A && !O, we = F && (_ || G), j = A && O, ee = !$ && !x && !_ && !F && !B, Q = ee || he || X, me = x || !F || L, te = !$ && !B && D.length > 0 && (x || we), q = $ ? i.passwordSavedTitle : Z ? i.emailSentTitle : A ? i.expiredLinkTitle : ee ? i.forgotPasswordTitle : i.title, re = ee || A;
  return /* @__PURE__ */ o("main", { className: "min-h-screen bg-surface-container-lowest", children: /* @__PURE__ */ h("div", { className: "flex min-h-screen flex-col", children: [
    /* @__PURE__ */ o("div", { className: "flex min-h-[64px] items-center bg-surface-container-lowest px-(--spacing-16)", children: /* @__PURE__ */ o(fe, { "aria-label": i.assetWatchLabel }) }),
    /* @__PURE__ */ o(It, { "aria-hidden": !0, variant: "full-width" }),
    /* @__PURE__ */ h("div", { className: "flex flex-1 flex-col items-center justify-between px-(--spacing-20)", children: [
      /* @__PURE__ */ o("div", { className: "flex w-full justify-center pt-(--spacing-40) md:pt-(--spacing-80)", children: /* @__PURE__ */ o("div", { className: "w-full max-w-[480px]", children: /* @__PURE__ */ h(C, { gap: 40, fullWidth: !0, children: [
        /* @__PURE__ */ h(C, { align: "center", gap: 16, fullWidth: !0, children: [
          /* @__PURE__ */ o("div", { className: "[&_svg]:h-auto [&_svg]:w-[90px]", children: /* @__PURE__ */ o(fe, { "aria-hidden": !0, tone: "default" }) }),
          /* @__PURE__ */ o(xe, { align: "center", as: "h1", size: "sm", children: q }),
          /* @__PURE__ */ o("div", { className: Z ? "w-full" : "max-w-[334px]", children: /* @__PURE__ */ o(U, { align: "center", tone: "subtext", children: $ ? i.passwordSavedMessage : Z ? /* @__PURE__ */ h(W, { children: [
            i.emailSentMessage,
            /* @__PURE__ */ o("br", {}),
            /* @__PURE__ */ o("span", { className: "font-(number:--font-weight-semibold) text-text-default", children: D })
          ] }) : A ? i.expiredLinkDescription : Q ? i.forgotPasswordDescription : i.description }) })
        ] }),
        oe && !$ ? /* @__PURE__ */ o(Qe, { tone: oe.tone, title: oe.message }) : null,
        $ ? /* @__PURE__ */ o(T, { fullWidth: !0, type: "button", onClick: d, children: i.continueToSignIn }) : /* @__PURE__ */ h(C, { gap: 24, children: [
          A && !Q ? /* @__PURE__ */ h(W, { children: [
            /* @__PURE__ */ o(
              T,
              {
                disabled: !j,
                fullWidth: !0,
                loading: a,
                loadingText: i.loadingSendingCode,
                type: "button",
                onClick: () => {
                  ie();
                },
                children: i.sendNewLink
              }
            ),
            /* @__PURE__ */ o(
              T,
              {
                type: "button",
                variant: "ghost",
                onClick: d,
                children: i.backToSignIn
              }
            )
          ] }) : null,
          Q ? /* @__PURE__ */ o(
            wr,
            {
              canSendCode: se,
              email: l,
              isSendingCode: a,
              messages: i,
              onEmailChange: (v) => p(v.currentTarget.value),
              onSubmit: (v) => {
                ie(v);
              }
            }
          ) : null,
          te ? /* @__PURE__ */ o(
            pr,
            {
              canConfirm: J,
              confirmPassword: z,
              isConfirming: n,
              messages: i,
              newPassword: N,
              newPasswordError: R,
              onConfirmPasswordChange: (v) => H(v.currentTarget.value),
              onNewPasswordChange: (v) => {
                I(v.currentTarget.value), f(null);
              },
              onResetCodeChange: (v) => b(v.currentTarget.value),
              onSubmit: (v) => {
                de(v);
              },
              passwordValidation: ce,
              resetCode: c,
              showResetCodeInput: me
            }
          ) : null
        ] })
      ] }) }) }),
      re ? /* @__PURE__ */ o("div", { className: "w-full py-(--spacing-40)", children: /* @__PURE__ */ h(Ce, { gap: 0, justify: "center", children: [
        /* @__PURE__ */ o(U, { as: "span", tone: "subtext", children: i.supportQuestion }),
        /* @__PURE__ */ o(
          T,
          {
            render: /* @__PURE__ */ h(
              "a",
              {
                "aria-label": i.reachOutToSupport,
                href: g,
                children: [
                  i.reachOutToSupport,
                  /* @__PURE__ */ o(
                    Me,
                    {
                      "aria-hidden": !0,
                      name: "arrow-up-right",
                      size: "sm",
                      tone: "inherit"
                    }
                  )
                ]
              }
            ),
            size: "sm",
            variant: "ghost",
            children: i.reachOutToSupport
          }
        )
      ] }) }) : null
    ] })
  ] }) });
}
function Vr(e) {
  return Ke({
    mutationFn: ({ username: r }) => gt({ username: r }),
    ...e
  });
}
function Wr(e) {
  return Ke({
    mutationFn: ({
      confirmationCode: r,
      newPassword: t,
      username: s
    }) => pt({
      username: s,
      confirmationCode: r,
      newPassword: t
    }),
    ...e
  });
}
const gr = [
  "Engineering"
], rt = "Engineering", fr = "Product";
function mr(e) {
  return e.flatMap((r) => r?.split(/[,;]/) ?? []).map((r) => r.trim()).filter(Boolean);
}
function ot(e, r = gr) {
  if (!e)
    return !1;
  const t = new Set(r);
  return mr([
    e.role,
    ...e.roles ?? [],
    ...e.cognitoGroups ?? []
  ]).some((s) => t.has(s));
}
function zr(e) {
  return ot(e, [rt]);
}
function Hr(e) {
  return ot(e, [rt, fr]);
}
export {
  Or as AuthLaunchDarklyProvider,
  Tr as AuthProvider,
  Nr as AuthenticatedAppGate,
  _e as COGNITO_GROUP_NIKOLA_TEAM,
  Zt as CustomLoginForm,
  K as DEFAULT_CUSTOM_LOGIN_FORM_MESSAGES,
  gr as DEFAULT_RELEASE_INFO_ROLES,
  rt as ENGINEERING_ROLE,
  fr as PRODUCT_ROLE,
  Ze as PasswordRequirements,
  Ur as ResetPasswordPage,
  Dr as buildAuthCustomLoginFormMessages,
  tt as buildAuthPasswordRequirementLabels,
  Fr as buildAuthResetPasswordPageMessages,
  _r as configureSharedCookieAuth,
  kr as createAuthenticatedFetch,
  qr as createCurrentUserProvisionValidator,
  $r as createLoginMethodLookup,
  Hr as isEngineeringOrProductUser,
  zr as isEngineeringUser,
  rr as isNikolaTeamCognitoGroup,
  or as isNikolaTeamMember,
  ot as isReleaseInfoUser,
  tr as mapLoginLookupResponse,
  Ar as resolveAssetWatchCognitoConfig,
  kt as signOutCurrentClient,
  $t as signOutEverywhere,
  Je as useAuth,
  Wr as useConfirmPasswordResetMutation,
  Mr as useLaunchDarklyStatus,
  Vr as useSendPasswordResetCodeMutation
};
